import { render, staticRenderFns } from "./DonateCardSuccess.vue?vue&type=template&id=5b8a70f8&scoped=true&"
import script from "./DonateCardSuccess.vue?vue&type=script&lang=js&"
export * from "./DonateCardSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DonateCardSuccess.vue?vue&type=style&index=0&id=5b8a70f8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a70f8",
  null
  
)

export default component.exports